var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:['menu-item', {'icon-selected-menu': _vm.selected }]},[_c('a',{on:{"click":_vm.menuSelect}},[_c('i',{class:("icon-" + (_vm.item.icon))})])])}
var staticRenderFns = []

export { render, staticRenderFns }